import { graphql } from 'apollo';
import { MEMBERSHIP_QUERY } from 'hooks/useMembership';

/**
 *  @deprecated
 *  Due to change of design patterns (preferable function components instead of class components)
 *  you should use hooks/usePermissions instead whenever it is possible
 */

const withPermissions = graphql(MEMBERSHIP_QUERY, {
  props: ({ data: { viewer, organizationPk, loading } }) => {
    const currentMembership = viewer.currentUser.memberships.find(
      ({ organization }) => organizationPk === organization.pk,
    );
    const {
      role: { permissions },
    } = currentMembership;

    if (loading) return {};

    return {
      permissions,
    };
  },
});

export default withPermissions;
